import { render, staticRenderFns } from "./RealTimeSettings.vue?vue&type=template&id=ebaebe84"
import script from "./RealTimeSettings.vue?vue&type=script&lang=js"
export * from "./RealTimeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports